import React from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  customDatePicker: {
    // Label color in default
    // #108ee9, #001529
    width: 250,
    "& .MuiInputLabel-root": {
      color: "#6c757d",
      fontSize: 11,
      fontWeight: 600,
      letterSpacing: "0.5px",
      fontFamily: "Roboto",
    },

    // Label color when focused
    "& .MuiInputLabel-root.Mui-focused": {
      color: "#012970",
      fontSize: 14,
    },

    // Label color with field without focused
    "& .MuiInputLabel-shrink": {
      fontSize: 14,
    },

    // Border color in default mode
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#adb5bd",
    },

    // Border color when focused
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#012970",
    },

    // Fontsize when typing in Textfield
    "& .MuiInputBase-input": {
      color: "#282829",
      fontSize: 12,
      fontWeight: "600",
      fontFamily: "'Roboto', sans-serif",
    },
  },
}));

export default function MuiDatePicker({
  label,
  value,
  onChange,
  open,
  onClose,
  slotProps,
  ...other
}) {
  const classes = useStyles();

  const combinedSlotProps = {
    textField: {
      size: "small",
      variant: "outlined",
      className: classes.customDatePicker,
      ...slotProps?.textField, // Ensure props passed from the parent are applied
    },
  };

  return (
    <DatePicker
      label={label}
      format="DD/MM/YYYY"
      value={value}
      onChange={onChange}
      open={open}
      onClose={onClose}
      slotProps={combinedSlotProps}
      slots={{
        openPickerButton: () => null,
      }}
      {...other}
    />
  );
}
